<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>下注</v-card-title>

    <v-list dense>
      <v-list-tile>
        <v-list-tile-content>登入名稱:</v-list-tile-content>
        <v-list-tile-content class="align-end">{{ uid }}</v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>場次:</v-list-tile-content>
        <v-list-tile-content class="align-end">{{ bettingRace }}</v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>下注馬匹:</v-list-tile-content>
        <v-list-tile-content class="align-end">{{ bettingHorse.馬名 }}</v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>下注類型:</v-list-tile-content>
        <v-list-tile-content class="align-end">{{ betDialogType }}</v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>現時賠率:</v-list-tile-content>
        <v-list-tile-content class="align-end">{{ bettingHorse[betDialogType] }}</v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>預計回報:</v-list-tile-content>
        <v-list-tile-content class="align-end">{{ numberWithCommas(caculateOdds) }}</v-list-tile-content>
      </v-list-tile>
      <v-form v-model="betDialogFormValid">
        <v-card-text>
          <v-text-field
            v-model="betAmount"
            v-on:keypress="isNumber()"
            :rules="betDialogFormRules"
            label="金額"
            required
          ></v-text-field>
          <v-text-field v-model="betReason" label="原因(選填)" required></v-text-field>
          <v-btn color="primary" @click="betReason = '支持'+bettingHorse.騎師">支持{{bettingHorse.騎師}}</v-btn>
          <v-btn color="primary" @click="betReason = '支持'+bettingHorse.練馬師">支持{{bettingHorse.練馬師}}</v-btn>
          <v-btn color="primary" @click="betReason = '感覺'">感覺</v-btn>
          <v-btn color="primary" @click="betReason = '吊柒馬會'">吊柒馬會</v-btn>
        </v-card-text>
      </v-form>
    </v-list>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="$emit('cancel-clicked')">取消</v-btn>
      <v-btn
        color="primary"
        flat
        @click="doubleConfirm()"
        :disabled="isBetDialogValid"
      >{{doubleConfirmText}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["uid", "bettingRace", "bettingHorse", "betDialogType","callback"],
  data() {
    return {
      betAmount: "",
      betDialogFormValid: false,
      betReason: "",
      betDialogFormRules: [v => !isNaN(v)],
      doubleConfirmed: false,
      doubleConfirmText: "確認"
    };
  },
  methods: {
    doubleConfirm() {
      if (!this.doubleConfirmed) {
        this.doubleConfirmed = true;
      } else {
        this.callback(this.betAmount,this.betReason);
      }
    },
    numberWithCommas: function(x) {
      if (x != null && x && !isNaN(x)) {
        return "$" + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "";
    },
    isNumber: function() {
      const evt = window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      //More than one decimal place
      if (charCode == 46 && this.betAmount.indexOf(".") > -1) {
        evt.preventDefault();
        return;
      }
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  watch: {
    doubleConfirmed: function(val) {
      this.doubleConfirmText = val ? "是否確認?" : "確認";
    }
  },
  computed: {
    caculateOdds: function() {
      return (
        parseFloat(this.bettingHorse[this.betDialogType]) *
        parseFloat(this.betAmount)
      ).toFixed(2);
    },
    isBetDialogValid: function() {
      return isNaN(parseInt(this.betAmount));
    }
  }
};
</script>

<style scoped>
</style>